import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { context } from 'customer-flows/utils/core'

class FlowTemplate extends Component {
  @context('application') legacyProgramId: ApplicationStore['legacyProgramId']

  <template>
    <div
      data-testid='flow-container'
      data-legacyprogramid={{this.legacyProgramId}}
      class='bg-neutrals-0 in-frame:bg-transparent sm:in-frame:flex sm:in-frame:justify-center @container/flow min-h-full w-full'
    >
      <div
        data-testid='flow'
        class='@sm/flow:in-frame:m-8 @sm/flow:in-frame:h-fit @sm/flow:in-frame:max-w-285 @sm/flow:in-frame:rounded-3 @sm/flow:in-frame:bg-neutrals-0 @sm/flow:in-frame:shadow-cool-raised relative h-full w-full'
      >
        <div
          data-testid='flow__content'
          class='@sm/flow:in-frame:rounded-3 @sm/flow:in-frame:[clip-path:inset(0_round_12px)] h-full w-full relative'
        >
          {{outlet}}
        </div>
      </div>
    </div>
  </template>
}

export default RouteTemplate(FlowTemplate)
